import React from "react";

export const Svg: React.FC<React.SVGProps<SVGSVGElement>> = ({
  width,
  height,
  style,
  children,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      height={height}
      fontFamily="TheMixSemilight, sans-serif"
      fontWeight="400"
      style={{
        display: "block",
        background: "white",
        borderRadius: "5px",
        ...style,
      }}
      {...props}
    >
      {children}
    </svg>
  );
};
